import { useLocation, useNavigate } from 'react-router-dom';
import { useAnalyticsContext } from '../../../context/analytics-context';
import { useInitializationDataContext } from '../../../context/data-context/data-context';
import { updateAddresses, updateDigitalAddress } from '../../../context/data-context/data-context-actions';
import { useDataContext } from '../../../context/data-context/use-data-context';
import {
  AddressForm as AddressFormData,
  AddressTypes,
  EmailAddressForm as EmailAddressFormData,
} from '../../../global-types';
import useAddressSelection from '../../../hooks/use-address-selection';
import { useIsOneToMany } from '../../../hooks/use-is-one-to-many';
import { getRegionalConfig } from '../../../regional-config';
import { updateProductQuantity } from '../../../services/customization';
import { useEditorNavigation } from '../../editor/hooks/use-editor-navigation';

export const useAddressGoBack = ({ isDigitalGreeting, envelope }) => {
  // Contexts
  const {
    initializedDataState: { data: initializedData, addressData },
    initializationDataDispatch,
  } = useInitializationDataContext();

  const {
    initializedDataState: { isRecipientAddress },
    setIsRecipientAddress,
  } = useDataContext();

  const { maxCount: quantity } = useAddressSelection();

  const {
    addressForm: { shouldShowOneToManyEnvelopePreview },
  } = getRegionalConfig();
  const { handleIndexChange } = useEditorNavigation();
  const { trackReturnToEdit } = useAnalyticsContext();

  const isOneToMany = useIsOneToMany();

  // Routing
  const navigate = useNavigate();
  const { search } = useLocation();

  const goBack = (addressFormValues: AddressFormData, emailAddressFormValues: EmailAddressFormData) => {
    if (isDigitalGreeting) {
      const currentEmailAddress = { ...addressData.digital, ...emailAddressFormValues };
      updateDigitalAddress(initializationDataDispatch, currentEmailAddress);
    } else {
      const currentAddressType = isRecipientAddress ? AddressTypes.RECIPIENT : AddressTypes.SENDER;
      const currentAddress = { ...addressData[String(currentAddressType)], ...addressFormValues };

      if (!isOneToMany) {
        updateAddresses(initializationDataDispatch, { [currentAddressType]: currentAddress });
      }
    }

    if (isRecipientAddress) {
      setIsRecipientAddress(false);
      return;
    }

    trackReturnToEdit();
    const searchParams = new URLSearchParams(search);

    if (shouldShowOneToManyEnvelopePreview && envelope) {
      searchParams.set('envelope', envelope);
    }

    const lastProjectLoaded = sessionStorage.getItem('lastProjectLoaded');
    const editorUrl = lastProjectLoaded
      ? `/card/customization/edit/${lastProjectLoaded}`
      : `/card/customization/edit/${initializedData?.project_id}`;

    navigate({ pathname: editorUrl, search: searchParams.toString() });
    void updateProductQuantity(String(quantity), initializedData?.project_id);
    handleIndexChange(0, 0);
  };

  return {
    goBack,
  };
};
